/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { ReportHandler } from 'web-vitals';

// Enhanced Web Vitals reporting with analytics integration
const reportWebVitals = (onPerfEntry?: ReportHandler): any => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      // Core Web Vitals
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

// Function to send Web Vitals to Google Analytics
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const sendToGoogleAnalytics = ({ name, delta, id }: any) => {
  const eventPayload = {
    event_category: 'Web Vitals',
    event_label: id,
    value: Math.round(name === 'CLS' ? delta * 1000 : delta),
    non_interaction: true,
  };

  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', name, eventPayload);
  } else if (typeof window !== 'undefined' && (window as any).dataLayer) {
    (window as any).dataLayer.push({
      event: 'web_vitals',
      metric_name: name,
      metric_id: id,
      ...eventPayload,
    });
  }
};

// No custom analytics endpoint is needed here. Kept as a no-op for
// backward compatibility with existing imports.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const sendToAnalytics = (_metric: any) => {
  /* no-op */
};

// Enhanced reporting function that combines multiple analytics
export const reportWebVitalsEnhanced = () => {
  reportWebVitals((metric) => {
    // Send to Google Analytics
    sendToGoogleAnalytics(metric);

    // Send to custom analytics
    sendToAnalytics(metric);

    // Avoid production console work; metrics are reported above.
  });
};

export default reportWebVitals;
